import { createSlice } from '@reduxjs/toolkit';

import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { TTimerOption } from 'commonTypes/api/scenarios/CreditOffersLoadingContent';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import { setScenario } from 'entities/scenario';

export interface TimerState {
  remaining: number;
  options: TTimerOption[];
}

const initialState: TimerState = {
  remaining: 0,
  options: [],
};

export const creditTimerSlice = createSlice({
  name: 'creditTimer',
  initialState,
  reducers: {
    tick(state) {
      state.remaining = Math.max(state.remaining - 1, 0);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setScenario, (state, { payload }) => {
      if (payload.step === SCENARIO_STEP.CREDIT_OFFERS_LOADING) {
        const content = payload.content as ContentOfType<SCENARIO_STEP.CREDIT_OFFERS_LOADING>;

        state.remaining = content.timer.initialDuration;
        state.options = content.timer.options;
      }
    });
  },
});

export const { tick } = creditTimerSlice.actions;
